// extracted by mini-css-extract-plugin
module.exports = {"panelQuestion":"faq-module--panelQuestion---MboC","panelAnswer":"faq-module--panelAnswer--2RJ6X","panel":"faq-module--panel--3ih_8"};